import {
  ApiConfig,
  RequestService
} from 'web-common/services/request/RequestService'
import {AppConfig} from 'AppConfig'

const paths = {
  'transcribe-audio': {},
  requireToken: true,
  toString: () => AppConfig.api.assistant
}

interface TranscribeAudioResponse {
  transcription: string
}

class AssistantAudioService extends RequestService {
  protected api = new ApiConfig<typeof paths>(paths)

  protected static instance: AssistantAudioService

  static shared() {
    return (
      AssistantAudioService.instance ??
      (AssistantAudioService.instance = new AssistantAudioService())
    )
  }

  public async transcribeAudio(data: FormData): Promise<string> {
    const result = await this.api.paths[
      'transcribe-audio'
    ].post<TranscribeAudioResponse>(this.request)(data)
    return result.transcription
  }
}

export default AssistantAudioService
